import { Col } from "react-grid-system";
import styled from "styled-components";

export const StyledDecisionDetails = styled(Col)`
	> div {
		margin-top: 1.2rem;
		&:first-child {
			margin-top: 0;
		}
	}
`;
